var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25613 6.602C1.93813 3.327 4.78913 1 7.99613 1C11.2031 1 14.0531 3.327 14.7361 6.602C14.7632 6.73196 14.8408 6.84584 14.9518 6.91861C15.0628 6.99137 15.1982 7.01705 15.3281 6.99C15.4581 6.96295 15.572 6.88538 15.6447 6.77436C15.7175 6.66334 15.7432 6.52796 15.7161 6.398C14.9391 2.673 11.6891 0 7.99613 0C4.30313 0 1.05313 2.673 0.276131 6.398C0.249079 6.52796 0.274759 6.66334 0.347523 6.77436C0.420288 6.88538 0.534175 6.96295 0.664131 6.99C0.794087 7.01705 0.929467 6.99137 1.04049 6.91861C1.15151 6.84584 1.22908 6.73196 1.25613 6.602ZM7.98613 3C8.91439 3 9.80463 3.36875 10.461 4.02513C11.1174 4.6815 11.4861 5.57174 11.4861 6.5C11.4861 7.42826 11.1174 8.3185 10.461 8.97487C9.80463 9.63125 8.91439 10 7.98613 10C7.05787 10 6.16763 9.63125 5.51126 8.97487C4.85488 8.3185 4.48613 7.42826 4.48613 6.5C4.48613 5.57174 4.85488 4.6815 5.51126 4.02513C6.16763 3.36875 7.05787 3 7.98613 3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPasswordIcon);
export default __webpack_public_path__ + "static/media/showPasswordIcon.d585e4072cf04155480c167e14f420c8.svg";
export { ForwardRef as ReactComponent };